import React from "react";
import "../styles/OrderStatus.css";

const OrderFailed = () => {
    return (
        <div className="order-status-container">
            <img src="/images/payment-failed.png" alt="결제 실패" className="order-status-img" />
            <p className="order-status-fail-text">결제에 실패 하였습니다.<br />다시 시도해 주세요.</p>
        </div>
    );
};

export default OrderFailed;
